module.exports = __webpack_public_path__ + "3aaa6a39b5986f932dbe13d5fb376667.png";